import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FilterPanelComponent } from './components/filter-panel/filter-panel.component';
import {
  BadgeComponent,
  ColComponent,
  IColumn,
  OffcanvasModule,

  RowComponent,
  SmartTableComponent,
  TemplateIdDirective,
} from '@coreui/angular-pro';

import { DataTablesModule } from 'angular-datatables';
import { VehicleData } from '../../models/vehicle.model';
import { VehicleDataService } from '../../services/vehicle-data.service';
import { CommonModule } from '@angular/common';
import { Params, Router, RouterLink } from '@angular/router';
import { GlobalDataService } from '../../services/global-data.service';
import { VehicleConsecutiveDaysService } from '../../services/vehicle-consecutive-days.service';
import { VehicleConsecutiveDays } from '../../models/vehicle-consecutive-days.model';
import { concatMap } from 'rxjs';

@Component({
  selector: 'app-daily-vehicle-count',
  standalone: true,
  templateUrl: './daily-vehicle-count.component.html',
  styleUrl: './daily-vehicle-count.component.scss',
  imports: [
    FilterPanelComponent,
    BadgeComponent,
    RowComponent,
    ColComponent,
    DataTablesModule,
    CommonModule,
    SmartTableComponent,
    TemplateIdDirective,
    RouterLink,
    OffcanvasModule,
  ],
})
export class DailyVehicleCountComponent implements OnInit {
  vehicleData: VehicleData[] = [];
  OffcanvasStart = false;
  queryParams!: Params;
  vehicleConsecutiveDaysData: VehicleConsecutiveDays[] = [];
  isCanvasLoading = false;
  constructor(
    private vehicleDataService: VehicleDataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private global: GlobalDataService,
    private vehicleConsecutiveDaysService: VehicleConsecutiveDaysService
  ) {}

  ngOnInit(): void {
    this.loadVehicleData(this.getSnapshotDates('TODAY'));
  }

  loadVehicleData(filter?: any) {
    this.vehicleDataService
      .getVehicleData(filter)
      .subscribe((data: VehicleData[]) => {
        this.global.departmentHierarchyObservable.subscribe((departmentData) => {
          data.forEach((vehicleDataInstance: any) => {
            vehicleDataInstance['view'] = this.findRegionByRegionId(
              departmentData,
              vehicleDataInstance['region_id']
            );
            console.log(vehicleDataInstance.view);
            vehicleDataInstance['view']['depotId'] =
              vehicleDataInstance['depot_id'];
            vehicleDataInstance['view']['snapshot_date'] =
              vehicleDataInstance['snapshot_date'];
          });
          this.vehicleData = data;
          this.cdr.detectChanges();
        });
      });
  }

  columns: IColumn[] = [
    {
      key: 'snapshot_date',
      label: 'Date',
      _style: { width: '20%' },
      _data: { tooltip: 'Date Registered', icon: 'cilCalendar' },
    },
    {
      key: 'unutilized_count',
      label: 'Vehicle Count',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
    {
      key: 'depot_name',
      label: 'Depot Name',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
    {
      key: 'region_name',
      label: 'Region',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
      _data: { tooltip: 'User Status', icon: 'cilBadge' },
    },
    {
      key: 'view',
      label: 'View Details',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
  ];
  topUnsedColumns: IColumn[] = [
    {
      key: 'vehicle_registration',
      label: 'Registration',
      _style: { width: '20%' },
      _data: { tooltip: 'Date Registered', icon: 'cilCalendar' },
    },
    {
      key: 'vehicle_depot',
      label: 'Depot',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
    {
      key: 'unutilized_count',
      label: 'Unused Count',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
    {
      key: 'total_count',
      label: 'Total Count',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
  ];

  findRegionByRegionId(data: any[], regionId: number) {
    for (let i = 0; i < data.length; i++) {
      const regions = data[i].regions;

      for (let j = 0; j < regions.length; j++) {
        if (regions[j].id === regionId) {
          return {
            departmentId: data[i].id,
            regionId: regions[j].id,
          };
        }
      }
    }
    return null;
  }

  navigateToDepotSummary(data: any) {
    this.OffcanvasStart = true;
    // this.router.navigate(
    //   [
    //     `/department/${data.departmentId}/region/${data.regionId}/depot/${data.depotId}/unutilised`,
    //   ],
    //   {
    //     queryParams: {
    //       snapshot_date_start: data.snapshot_date,
    //       snapshot_date_end: data.snapshot_date,
    //     },
    //   }
    // );
    this.queryParams =  {
          queryParams: {
            depot_id: data.departmentId,
            snapshot_date_start: data.snapshot_date,
            snapshot_date_end: data.snapshot_date,
          },
        }
    this.getSideCanvasData(this.queryParams)
  }

  onFilterChange($event: any) {
    let query: any = {};

    if ($event.selectedDepot) query['depot_id'] = `${$event.selectedDepot}`;
    if ($event.selectedRegion) query['region_id'] = `${$event.selectedRegion}`;

    query = {
      ...this.getSnapshotDates($event.selectedDateRangeName),
      ...query,
    };

    this.loadVehicleData(query);
  }

  getSnapshotDates(value: string): {
    snapshot_date_start: string;
    snapshot_date_end: string;
  } {
    const today = new Date();

    let snapshot_date_start: string;
    let snapshot_date_end: string;

    function formatDate(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    switch (value) {
      case 'TODAY':
        snapshot_date_start = formatDate(today);
        snapshot_date_end = formatDate(today);
        break;

      case 'THIS_WEEK':
        const startOfWeek = new Date(today);
        const endOfWeek = new Date(today);

        // Get the current day of the week (0 = Sunday, 1 = Monday, etc.)
        const dayOfWeek = today.getDay();

        // Calculate the start and end of the week (assuming the week starts on Sunday)
        startOfWeek.setDate(today.getDate() - dayOfWeek); // Set to Sunday
        endOfWeek.setDate(today.getDate() + (6 - dayOfWeek)); // Set to Saturday

        snapshot_date_start = formatDate(startOfWeek);
        snapshot_date_end = formatDate(endOfWeek);
        break;

      case 'THIS_MONTH':
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the month
        const endOfMonth = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        ); // Last day of the month

        snapshot_date_start = formatDate(startOfMonth);
        snapshot_date_end = formatDate(endOfMonth);
        break;

      default:
        throw new Error('Invalid value provided');
    }

    return { snapshot_date_start, snapshot_date_end };
  }



  // Side canvass

  getSideCanvasData(params: Params)
  {
    this.isCanvasLoading = true;
    console.log(params)
    let _params = {'depot_id': params['depotId']}

    if(!(Object.keys(this.queryParams).length === 0)){
      _params = {..._params, ...this.queryParams} 
    }
    else{
      _params = {..._params, ...this.getLast30Days()}
      console.log(_params)

    }


    this.vehicleConsecutiveDaysService.getVehicleConsecutiveDays(params).pipe(concatMap((data) => {
      this.vehicleConsecutiveDaysData= data;
      this.isCanvasLoading = false;
      this.cdr.detectChanges();
      return this.vehicleConsecutiveDaysService.getVehicleCategories() as any
    })).subscribe((categories : any)=> {
      console.log(categories)
      this.isCanvasLoading = false;
      this.cdr.detectChanges();

    })
  }

  getLast30Days(): { snapshot_date_start: string, snapshot_date_end: string } {
    const today = new Date();
    
    // Helper function to format the date as 'YYYY-MM-DD'
    function formatDate(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  
    // Get the end date (today)
    const snapshot_date_end = formatDate(today);
    
    // Get the start date by subtracting 30 days
    const snapshot_date_start = new Date(today);
    // Subtracting 29 days, because both start and end dates are included in backend filtering
    snapshot_date_start.setDate(today.getDate() - 29); // Subtract 29 days
    
    // Format the start date
    const formatted_snapshot_date_start = formatDate(snapshot_date_start);
  
    return { snapshot_date_start: formatted_snapshot_date_start, snapshot_date_end };
  }


}
